<template>
  <div>
    <div
      v-for="(seller, idx) of sellers"
      :key="idx"
      outlined
      class="pb-3 mb-3"
    >
      <div class="mb-3 helmi-card-title">
        {{ idx + 1 }}.{{ seller.roles?.map(role => {
            const roles = {
              ORGANIZATION: 'Yritys',
              ORGANIZATION_SIGNER: 'Yrityksen edustaja',
              SIGNER: 'Myyjä',
              ESTATE: 'Kuolinpesä',
              ESTATE_SIGNER: 'Kuolinpesän edustaja',
              LUONNOKSEN_VASTAANOTTAJA: 'Luonnoksen vastaanottaja'
            }

            return roles[role];
        }).join(', ') }}
      </div>

      <p
        v-if="seller.roles.includes('ORGANIZATION_SIGNER')"
        class="mt-n5 mb-3 text-subtitle-2 font-weight-regular grey--text text--darken-1"
      >
        <b class="text-subtitle-2 font-weight-bold">Edustaa yrityksiä:</b> {{
          seller.businessIds?.map(
            businessId => getCompanyName(businessId)).join(', ')
        }}
      </p>

      <v-row>
        <template v-if="seller.roles.includes('ORGANIZATION')">
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="seller.organization.name"
              label="Nimi"
              :rules="[rules.required]"
              @input="updateBody()"
            />
          </v-col>

          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="seller.organization.businessId"
              label="VAT-tunnus"
              disabled
            />
          </v-col>
        </template>

        <template v-else>
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="seller.person.firstName"
              label="Etunimi"
              :rules="[rules.required]"
              @input="updateBody()"
            />
          </v-col>
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="seller.person.lastName"
              label="Sukunimi"
              :rules="[rules.required]"
              @input="updateBody()"
            />
          </v-col>
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="seller.person.socialSecurityNumber"
              label="Henkilötunnus"
              :rules="[rules.required]"
              @input="updateBody(true)"
            />
          </v-col>

          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="seller.person.email"
              :rules="[rules.required, rules.email]"
              label="Sähköposti"
              @input="updateBody()"
            />
          </v-col>
        </template>
        <v-col
          v-if="seller.realtorPayment"
          md="6"
          cols="12"
          class="py-0"
        >
          <v-text-field
            v-model="seller.realtorPayment.amountInEuros"
            :rules="[rules.required]"
            label="Välityspalkkion osuus"
            append-icon="euro_symbol"
            type="number"
            @input="updateBody()"
          />
        </v-col>

        <v-col
          v-if="
              seller.roles?.includes('SIGNER') ||
            seller.roles?.includes('ORGANIZATION') ||
          seller.roles?.includes('ESTATE')"
          md="6"
          cols="12"
          class="py-0"
        >
          <v-autocomplete
            v-model="seller.bankBusinessId"
            :items="banks"
            label="Pankki"
            item-value="businessId"
            :rules="[rules.required]"
            item-text="combName"
            hint="Huom! Valinta vaihtaa kaikkien myyjien pankin"
            persistent-hint
            @change="setAllSellers(seller.bankBusinessId)"
          />
        </v-col>
        <v-col md="6" cols="12">
          <v-checkbox
            v-model="seller.roles"
            :rules="[draftReceiverSelected]"
            label="Luonnoksen vastaanottaja"
            value="LUONNOKSEN_VASTAANOTTAJA"
          />
        </v-col>
      </v-row>

      <v-divider v-if="idx < body.sellers?.length - 1 && body.sellers?.length > 1" class="mt-5"/>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    banks: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    colors: {
      base: 'primary',
      text: 'primary--text',
    },
    editing: false,
    sellers: [],
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
  }),

  computed: {
    draftReceiverSelected() {
      const hasSelections = this.sellers.some(s => s.roles.includes('LUONNOKSEN_VASTAANOTTAJA'));

      return hasSelections || 'Valitse vähintään yksi luonnoksen vastaanottaja.';
    },
  },

  watch: {
    body: {
      async handler(val) {
        if (!val.sellers) return;

        if (this.editing) {
          this.editing = false;
          return;
        }

        this.sellers = _.cloneDeep(val.sellers)
          .filter(seller => seller.roles?.length > 0)
          .map((seller) => {
            const item = seller;

            if (seller.realtorPayment) {
              item.realtorPayment = {
                amountInEuros: seller.realtorPayment.amountInCents / 100,
                referenceNumber: seller.realtorPayment.referenceNumber,
              };
            }

            return item;
          });
      },
      deep: true,
    },
  },

  methods: {
    updateBody(ssn = false) {
      this.editing = true;
      this.body.sellers = _.cloneDeep(this.sellers).map((seller) => {
        const item = seller;

        if (seller.realtorPayment) {
          item.realtorPayment = {
            amountInCents: Math.round(seller.realtorPayment.amountInEuros * 100),
            referenceNumber: seller.realtorPayment.referenceNumber,
          };
        }

        return item;
      });

      if (ssn) {
        this.body.luovutettavatOsuudet = [];

        this.body.sellers
          .filter(seller => !seller.roles.includes('ORGANIZATION'))
          .forEach((seller) => {
            this.body.luovutettavatOsuudet.push({
              osuus: '',
              sellerSocialSecurityNumbers: [seller.person.socialSecurityNumber],
            });
          });
      }
    },
    storePersonBank(personId, bankId) {
      localStorage.setItem(`person-bank-${personId}`, bankId);
    },

    setAllSellers(bank) {
      this.sellers.forEach((seller) => {
        this.storePersonBank(seller.id, bank);

        seller.bankBusinessId = bank; // eslint-disable-line
      });
      this.updateBody();
      this.$bus.$emit('GET_DIAS_CONFIG');
    },

    getCompanyName(businessId) {
      const company = this.body?.sellers.find(e => e.organization?.businessId === businessId);

      return company?.organization?.name || '';
    },
  },
};
</script>
